import { useMutation } from '@tanstack/react-query'
import { gql } from 'graphql-request'
import { useForm } from 'react-hook-form'
import { Check, Loader2 } from 'lucide-react'

import { request } from '@helpers/graphql'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'

const UPDATE_TUTOR_MUTATION = gql`
  mutation updateTutor($input: UpdateInput!) {
    updateTutor(input: $input) {
      tutor {
        id
        name
        createdAt
        description
        summary
        socratic
        suggestionsEnabled
        stemModeEnabled
        knowledgeBaseEnabled
        visibility
        approvedForCommunity
        image {
          url
        }
        userName
        organizationName
      }
    }
  }
`

const Settings = ({ tutorId, approvedForCommunity, refetch }) => {
  const { register, handleSubmit, formState: { isSuccess } } = useForm({
    mode: 'onTouched',
    defaultValues: { approvedForCommunity }
  })

  const { mutate: updateTutor, isLoading } = useMutation({
    mutationFn: async data => request(UPDATE_TUTOR_MUTATION, { input: { ...data, id: tutorId } }),
    onSuccess: () => refetch()
  })

  const onSubmit = data => updateTutor(data)

  return (
    <div className='w-auto px-5 py-3'>
      <form
        className='flex flex-col space-y-6'
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className='items-top flex space-x-2'>
          <Checkbox
            id='approvedForCommunity'
            defaultChecked={approvedForCommunity}
            {...register('approvedForCommunity')}
          />
          <div className="grid gap-1.5 leading-none">
            <Label
              htmlFor="approvedForCommunity"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Approved for community
            </Label>
          </div>
        </div>

        <div className='ml-auto flex items-center'>
          {isSuccess && (
            <Check className='mr-2 h-5 w-5 text-green-500' />
          )}

          <Button
            className='w-fit'
            disabled={isLoading}
            type='submit'
            loading={isLoading}
          >
            {isLoading ? 'Saving...' : 'Save changes'}
          </Button>
        </div>
      </form>
    </div>
  )
}

export default Settings
